export default "__VITE_ASSET__i2cFxBuS__"